/**
 * @generated SignedSource<<2099cad5ee4590296ebff3d7761e932f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePersonalizedNotificationTemplateInput = {
  clientMutationId?: string | null;
  id: string;
};
export type deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePersonalizedNotificationTemplateInput;
};
export type deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation$data = {
  readonly Admin: {
    readonly Notification: {
      readonly deletePersonalizedNotificationTemplate: {
        readonly deletedId: string;
      } | null;
    };
  };
};
export type deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation = {
  response: deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation$data;
  variables: deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePersonalizedNotificationTemplatePayload",
                "kind": "LinkedField",
                "name": "deletePersonalizedNotificationTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePersonalizedNotificationTemplatePayload",
                "kind": "LinkedField",
                "name": "deletePersonalizedNotificationTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedId",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "561d2910be4305e0800feb41a47f65c6",
    "id": null,
    "metadata": {},
    "name": "deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation deletePersonalizedNotificationTemplateButton_DeletePersonalizedNotificationTemplateMutation(\n  $input: DeletePersonalizedNotificationTemplateInput!\n) {\n  Admin {\n    Notification {\n      deletePersonalizedNotificationTemplate(input: $input) {\n        deletedId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "158c31fed239db802cf0bfbca3107acc";

export default node;
